/**
 * T-0559: the web's own marks on its cold boot, so a launch can be broken down where it is measured
 * (WebKit in a test, Safari's Web Inspector on a device) rather than guessed at.
 *
 * Each is one `performance.mark`, set once per document. What the marks leave out comes from the
 * browser's own timing: the document and every chunk from Resource Timing, the first paint from
 * Paint Timing, the first data from the `/api/` resources. `docs/concept-mobile-app.md`
 * (*Performance budgets*, T-0559) names each one and what it measures.
 */
export const BOOT_MARKS = {
  /** The entry module's body runs: every chunk it imports statically is fetched, parsed and run. */
  entry: 'featit:boot:entry',
  /** The stored sign-in is back (the shell's Keychain, the desktop's store) and React renders. */
  render: 'featit:boot:render',
  /** The stored session's check is sent (`/api/auth/me`), and when it is answered (I-1206). */
  sessionSent: 'featit:boot:session-sent',
  sessionAnswered: 'featit:boot:session-answered',
  /** The first screen has settled and the web has told the shell `ready`. */
  ready: 'featit:boot:ready',
  /** I-1478: a launch that was held for its content has it, and the shell's mark can go. */
  contentSettled: 'featit:boot:content-settled',
} as const;

export type BootMarkType = (typeof BOOT_MARKS)[keyof typeof BOOT_MARKS];

export function markBoot(name: BootMarkType): void {
  try {
    if (performance.getEntriesByName(name, 'mark').length === 0) performance.mark(name);
  } catch {
    // A browser without User Timing has nothing to record into; the boot itself is unaffected.
  }
}
